module.exports = __webpack_public_path__ + "assets/b2143d6b1bf0fff11dc1a8b7e4dc34e7-DSC_0800.jpg";